import Lenis from 'lenis';

const lenisOptions = {
	smoothWheel: true,
	lerp: 0.1,
	wheelMultiplier: 1,
	anchors: true,
	duration: 1.4
};

const setupLenis = () => {
	const globalWindow = window;
	if (globalWindow.lenis) return;

	const lenis = new Lenis(lenisOptions);
	globalWindow.lenis = lenis;

	const raf = (time) => {
		lenis.raf(time);
		globalWindow.requestAnimationFrame(raf);
	};

	globalWindow.requestAnimationFrame(raf);
};

export default setupLenis;
